import React, { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCopyToClipboard from 'react-copy-to-clipboard';

import { useGlobalToast } from '../contexts/globalToast';

interface CopyToClipboardProps {
  text: string;
  confirmationMessage: ReactNode;
  children?: ReactNode;
  onCopy?: () => Promise<void> | void;
  errorMessage?: ReactNode;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  children,
  text,
  confirmationMessage,
  onCopy,
  errorMessage
}) => {
  const { t } = useTranslation();
  const { setContents } = useGlobalToast();

  return (
    <>
      <ReactCopyToClipboard
        text={text}
        onCopy={async () => {
          try {
            await onCopy?.();
            setContents(confirmationMessage, 'confirmation');
          } catch (err) {
            setContents(errorMessage || t('Failed to copy.'), 'error');
          }
        }}
      >
        {children}
      </ReactCopyToClipboard>
    </>
  );
};

export default CopyToClipboard;
